<div class="content-wrapper-inner">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div class="filter-form">
    <audit-filter-form-component (onSubmit)="onFilter($event)"></audit-filter-form-component>
  </div>
  <div class="hr-line-dashed"></div>
  <div>
    <table class="w-100">
      <thead>
        <tr>
          <th class="w-sm">Time</th>
          <th class="user-column">User</th>
          <th class="w-sm">Action</th>
          <th class="w-md">URL</th>
          <th class="w-lg">Device</th>
          <th class="w-sm">Service</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows">
          <td class="w-sm">{{row.createdAt | date:'MMMM d, y' }} <br>{{ row.createdAt | date:'h:mm:ss a' }}</td>
          <td class="user-column">{{row.userEmail}}</td>
          <td class="w-sm" [innerHTML]="row.ui.title"></td>
          <td class="w-md">{{row.ui.url}}</td>
          <td class="w-lg">{{row.ip}} / {{row.userAgent}}</td>
          <td class="w-sm">{{row.service}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="d-flex justify-content-center mt-20">
    <button *ngIf="totalCount > rows.length" type="button" (click)="next()" class="btn btn-primary">More</button>
  </div>
</div>
